const API_BASE = process.env.REACT_APP_API_BASE || "http://localhost/webservices/dashboard";

async function request(path, options = {}) {
  const response = await fetch(`${API_BASE}${path}`, {
    headers: {
      "Content-Type": "application/json",
      ...(options.headers || {}),
    },
    ...options,
  });

  const payload = await response.json().catch(() => ({}));

  if (!response.ok || payload.status === false) {
    throw new Error(payload.message || "Request failed");
  }

  return payload.data;
}

export const api = {
  getDashboardHome: () => request("/home/summary.php"),

  getBillPayments: () => request("/bill-payments/summary.php"),
  getOperators: (category) =>
    request(`/operators/list.php${category ? `?category=${category}` : ""}`),

  getUsers: () => request("/users/list.php"),
  updateUserStatus: (userId, status) =>
    request("/users/update_status.php", {
      method: "POST",
      body: JSON.stringify({ user_id: userId, status }),
    }),

  getTransactions: () => request("/transactions/list.php"),
  transactionAction: (txnRef, action) =>
    request("/transactions/action.php", {
      method: "POST",
      body: JSON.stringify({ txn_ref: txnRef, action }),
    }),

  getInvoices: () => request("/invoices/list.php"),
  generateInvoice: (transactionId) =>
    request("/invoices/generate.php", {
      method: "POST",
      body: JSON.stringify({ transaction_id: transactionId }),
    }),

  getSupportSummary: () => request("/support/summary.php"),

  getTickets: () => request("/tickets/list.php"),
  getAgents: () => request("/agents/list.php"),
  createTicket: (payload) =>
    request("/tickets/create.php", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  updateTicket: (ticketRef, action, extra = {}) =>
    request("/tickets/update.php", {
      method: "POST",
      body: JSON.stringify({
        ticket_ref: ticketRef,
        action,
        ...extra,
      }),
    }),

  getSupportCalls: () => request("/support/calls/list.php"),
  createSupportCall: (payload) =>
    request("/support/calls/create.php", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  updateSupportCall: (callRef, action, extra = {}) =>
    request("/support/calls/update.php", {
      method: "POST",
      body: JSON.stringify({ call_ref: callRef, action, ...extra }),
    }),

  getWallets: () => request("/wallet/list.php"),

  getServiceStatus: () => request("/services/list.php"),
  refreshServiceStatus: () =>
    request("/services/refresh.php", { method: "POST", body: "{}" }),

  getRbac: () => request("/roles/list.php"),
  createRole: (roleName, permissions) =>
    request("/roles/create.php", {
      method: "POST",
      body: JSON.stringify({ role_name: roleName, permissions }),
    }),

  getSettings: () => request("/settings/list.php"),
  updateSetting: (settingKey, settingValue) =>
    request("/settings/update.php", {
      method: "POST",
      body: JSON.stringify({ setting_key: settingKey, setting_value: settingValue }),
    }),

  getReports: () => request("/reports/summary.php"),
};
